module.exports = __webpack_public_path__ + "img/circular-economy.24697e9a.png";